<template>
	<div id="pop__onetrust" class="animate" v-if="isTrustVisible" data-qa="cookie-consent-popover">
		<!-- Fechar o banner não equivale a aceitar cookies -->
		<button id="close__trust" type="button" :aria-label="$t('a11y.closeModal')" data-qa="cookie-consent-close-button" @click="dismissCookies">
			<Icons name="close" />
		</button>

		<!-- Texto do Popup -->
		<div id="pop__onetrust--text">
			<h2>
				<Icons name="cookie" />
				<span>{{ $t('ontrust.title') }}</span>
			</h2>
			<p>{{ $t('ontrust.copy') }}</p>
		</div>

		<!-- Botões de Aceitar e Rejeitar -->
		<div id="pop__onetrust--content">
			<router-link :to="$t('footer.privacyCookies.url')" class="link--country" data-qa="cookie-consent-policy-link">
				{{ $t('footer.privacyCookies.label') }}
			</router-link>
			<div id="pop__onetrust--content--btns">
				<AppButton variant="secondary" data-qa="cookie-consent-reject-button" @click="rejectCookies" small>
					{{ $t('ontrust.rejeitar') }}
				</AppButton>
				<AppButton variant="primary" data-qa="cookie-consent-accept-button" @click="acceptCookies" small>
					{{ $t('ontrust.aceitar') }}
				</AppButton>
			</div>
		</div>
	</div>
</template>
<script>
import Icons from '@/components/Icons.vue';
import AppButton from '@/components/ui/AppButton.vue';
import {
	denyGoogleConsent,
	getStoredGoogleConsent,
	grantGoogleConsent,
} from '@/services/consent.service';
import {
	denyClarityConsent,
	grantClarityConsent,
	tagClarityRoute,
} from 'ClarityService';

export default {
	components: {
		Icons,
		AppButton,
	},
	data() {
		return {
			isTrustVisible: true, // Controla a visibilidade do popup
		};
	},
	created() {
		// Verifica se já existe uma escolha no sessionStorage
		const cookiesStatus = getStoredGoogleConsent();
		if (cookiesStatus !== null) {
			this.isTrustVisible = false; // Esconde o popup se já houver escolha
		}
	},
	methods: {
		acceptCookies() {
			grantGoogleConsent();
			grantClarityConsent();
			tagClarityRoute(this.$route);
			this.closeTrust();
		},
		rejectCookies() {
			denyGoogleConsent();
			denyClarityConsent();

			const cookiesToDelete = [
				'_ga',         // Google Analytics
				'_gid',        // Google Analytics
				'_gat',        // Google Analytics
				'IDE',         // Google Ads
				'__gads',      // Google Ads
				'_fbp',        // Facebook Pixel
				'_fbc',        // Facebook Pixel
				'_tt_enable_cookie', // TikTok Pixel
				'_ttp',        // TikTok Pixel
			];

			cookiesToDelete.forEach(cookieName => {
				document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
				console.log(`Cookie ${cookieName} deletado.`);
			});

			// Limpar objetos globais de outros serviços
			if (window.fbq) {
				window.fbq = null;
				console.log('Facebook Pixel desativado.');
			}
			if (window.ttq) {
				window.ttq = null;
				console.log('TikTok Pixel desativado.');
			}
			this.closeTrust();
		},
		dismissCookies() {
			this.closeTrust();
		},
		closeTrust() {
			// Fecha o popup
			this.isTrustVisible = false;
		},
	},
};
</script>

<style lang="sass" scoped>
@use '../assets/sass/utilities/_colors' as *
@use '../assets/sass/utilities/_responsive' as *
@use '../assets/sass/utilities/_mixin' as *
@keyframes slideUp 
	0% 
		opacity: 0
		transform: translateY(100%)

	100% 
		opacity: 1
		transform: translateY(0)


#close__trust
	background: none
	position: absolute
	width: 20px
	right: 20px
	top: 20px
	color: var(--lg-mid-gray-200)

	&:hover
		color: var(--lg-red-active)

#pop__onetrust
	background-color: var(--white)
	border-radius: 1.25rem
	padding: 20px
	position: fixed
	height: min-content
	max-height: calc(100dvh - 2rem)
	overflow-y: auto
	bottom: calc(2rem + env(safe-area-inset-bottom, 0px))
	z-index: 3000
	opacity: 0
	width: auto
	inset-inline: 20px
	// box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px
	box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px
	+respond-to($breakpoint-sm-min)
		inset-inline: inherit
		width: min(100%, 600px)
		right: 9rem
		bottom: 2em
		
		

	&.animate
		animation: slideUp 0.8s cubic-bezier(.77,0,.175,1) 0.3s forwards
	

	&--text
		margin-bottom: 10px

		h2
			display: flex
			color: var(--black)
			align-items: center
			gap: 10px
			font-size: 1.125rem
			font-weight: 600
			margin-bottom: 15px
			text-transform: uppercase

			i
				width: 1rem

		p
			line-height: 1.2
			font-size: clamp(12px, var(--clamp), 14px)

	&--content
		display: flex
		justify-content: space-between
		align-items: center
		flex-direction: column
		gap: 1.2rem
		+respond-to($breakpoint-sm-min)
			flex-direction: row
			
		a
			color: var(--lg-red-active)
			font-size: 14px


		&--btns
			display: flex
			align-items: center
			gap: 12px

			.AppButton
				--p: 10px
			   

</style>
